<template>
  <div>
    <FeatureFlag v-if="schedulerReady" feature="scheduler_v2_ff_enabled">
      <template #featureEnabled>
        <component :is="schedulerComponent" v-if="schedulerComponent" />
      </template>
      <template #featureDisabled>
        <SchedulePage />
      </template>
    </FeatureFlag>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useFeatureFlag } from "@/lib/useFeatureFlag";

import FeatureFlag from "@/components/FeatureFlag.vue";
import SchedulePage from "@/Scheduler/SchedulePage.vue";
import SchedulePageV2 from "@/SchedulerV2/SchedulePageV2.vue";

const store = useStore();

const schedulerFeatureFlag = useFeatureFlag("scheduler_v2_ff_enabled");
const schedulerReady = ref(false);
const schedulerComponent = ref(null);
const fetchAdminPreferences = async () => {
  const preferences = await store.dispatch("fetchPreferences");

  const scheduler2Pref = preferences?.find(
    (pref: { key: string }) => pref.key === "scheduler_2"
  );

  if (scheduler2Pref?.enabled) {
    schedulerComponent.value = SchedulePageV2;
  } else {
    schedulerComponent.value = SchedulePage;
  }
};

watch(
  schedulerFeatureFlag,
  async (enabled) => {
    if (enabled) {
      await fetchAdminPreferences();
    }
    schedulerReady.value = true;
  },
  { immediate: true }
);
onMounted(() => {
  if (schedulerFeatureFlag.value) {
    fetchAdminPreferences();
  }
});
</script>
<style>
.scheduler2-modal-img {
  position: relative;
  left: -30px;
  width: calc(100% + 60px) !important;
  max-width: none;
}
</style>
